module.exports = __webpack_public_path__ + "media/images/soar/home-note-3614dbe895c4767c6e4c7b75e3823e95.png";